<template>
  <div class="portlet light">
    <div class="portlet-title">
      <div class="caption">
        <span class="caption-subject font-green-sharp bold uppercase">
          Consulta de Reservas e Bloqueios
        </span>
      </div>
    </div>

    <div class="portlet-body">
      <!-- Mesmo aviso do formulário desktop -->
      <div class="alert alert-warning">
        <i class="fa fa-exclamation-triangle"></i>
        Esta rotina não soma os movimentos de reservas e bloqueios feitos através de
        soluções desenvolvidas em camada específica ou de cliente. Caso não tenha
        certeza se possui desenvolvimento específico ou de cliente que gere movimentos
        de reserva e/ou bloqueio, não utilize esta rotina e entre em contato com o
        suporte.
      </div>

      <!-- Mensagem de erro -->
      <div v-if="temErros" class="alert alert-danger">
        <strong>Erro:</strong> {{ mensagemErro }}
      </div>

      <!-- Loading -->
      <div v-else-if="carregando" class="text-center loading-area">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
        <p>Carregando saldos...</p>
      </div>

      <!-- Grids: documentos em cima, lotes do documento selecionado embaixo (como no desktop) -->
      <div v-else-if="documentos.length > 0 || lotes.length > 0">
        <div class="info-bar">
          <span class="badge badge-primary">{{ documentos.length }} documentos</span>
          <span class="badge badge-warning">{{ lotes.length }} lotes</span>
        </div>

        <h4 class="titulo-grid">Documentos</h4>
        <recupera-saldos-grid
          :dados="documentos"
          modo-selecao="single"
          @linha-selecionada="selecionarDocumento"
        />

        <h4 class="titulo-grid">
          Lotes
          <small v-if="documentoSelecionado">do documento selecionado</small>
          <small v-else>de todos os documentos (selecione um documento para filtrar)</small>
        </h4>
        <recupera-saldos-grid
          :dados="lotesExibidos"
          :mostrar-coluna-lote="true"
          modo-selecao="none"
        />
      </div>

      <!-- Vazio -->
      <div v-else class="alert alert-info">
        <i class="fa fa-info-circle"></i> Nenhum registro encontrado com os filtros aplicados.
      </div>
    </div>
  </div>
</template>

<script>
import RecuperaSaldosGrid from "./RecuperaSaldosGrid.vue";

// Mesmo vínculo mestre-detalhe do desktop: filial, almoxarifado, produto, variação e documento de origem.
const CHAVES_DOCUMENTO = [
  "Filial",
  "Almoxarifado",
  "Produto",
  "Variacao",
  "Origem",
  "NumeroDocumento",
  "HandleOrigem",
];

export default {
  name: "RecuperaSaldosDetalhado",
  components: {
    RecuperaSaldosGrid,
  },
  data() {
    return {
      documentoSelecionado: null,
    };
  },
  computed: {
    documentos() {
      return this.$store.state.dadosRecuperaSaldos.saldos.map((item, index) => ({
        ...item,
        id: `doc-${index}`,
      }));
    },
    lotes() {
      return this.$store.state.dadosRecuperaSaldos.saldosLote.map((item, index) => ({
        ...item,
        id: `lote-${index}`,
      }));
    },
    lotesExibidos() {
      if (!this.documentoSelecionado) {
        return this.lotes;
      }

      return this.lotes.filter((lote) =>
        CHAVES_DOCUMENTO.every((chave) => lote[chave] === this.documentoSelecionado[chave])
      );
    },
    carregando() {
      return this.$store.state.dadosRecuperaSaldos.carregando;
    },
    temErros() {
      return this.$store.state.dadosRecuperaSaldos.temErros;
    },
    mensagemErro() {
      return this.$store.state.dadosRecuperaSaldos.mensagemErro;
    },
  },
  watch: {
    documentos() {
      this.documentoSelecionado = null;
    },
  },
  methods: {
    selecionarDocumento(linha) {
      this.documentoSelecionado = linha;
    },
  },
};
</script>

<style scoped>
.portlet {
  margin-bottom: 20px;
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.loading-area {
  padding: 20px;
}

.info-bar {
  padding: 15px;
  margin-bottom: 15px;
  background-color: #f5f5f5;
  border-radius: 4px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.info-bar .badge {
  font-size: 13px;
  padding: 6px 12px;
}

.titulo-grid {
  margin-top: 20px;
  margin-bottom: 0;
}

.titulo-grid small {
  font-size: 12px;
  color: #777;
}
</style>
